import { array, boolean, object, string } from 'yup'
import { ExcludedArea, ExcludedAreaDetails, ExcludedAreaType, ExcludedAreasResponse } from './location.types'

export const ExcludedAreaDetailsSchema = object<ExcludedAreaDetails>().shape({
  authority: string().optional(),
  phone: string().optional(),
})

export const ExcludedAreaSchema = object<ExcludedArea>().shape({
  type: string().oneOf([ExcludedAreaType.HIGHWAY_AUTHORITY]).required(),
  name: string().required(),
  details: ExcludedAreaDetailsSchema.optional(),
})

export const ExcludedAreasResponseSchema = object<ExcludedAreasResponse>().shape({
  inExcludedArea: boolean().required(),
  excludedAreas: array().of(ExcludedAreaSchema).defined(),
})
